import { DocumentVersionBestPracticeResultOverviewViewModel } from "@common/components/bestPracticeCheckDialog/BestPracticeCheckDialog.types.ts";

export interface SystemDocumentSaveModel {
    fileName: string | undefined;
    name: string;
    link: string | undefined;
}

export interface SystemDocumentRowViewModel {
    fileName: string | undefined;
    name: string;
    link: string | undefined;
    documentId: string;
    dataId: string | undefined;
    created: Date;
    systemDocumentId: string;
    isTooLargeForAi: boolean;
    aiQualityAssuranceResult?: DocumentVersionBestPracticeResultOverviewViewModel;
}

export class SystemDocument {
    documentId: string;
    fileName: string;
    name: string;
    link: string;

    constructor() {
        this.documentId = "";
        this.fileName = "";
        this.name = "";
        this.link = "";
    }
}

export class SystemDocumentViewModel {
    name: string | undefined = undefined;

    constructor(name: string | undefined) {
        this.name = name;
    }
}
